import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';

export type CustomerCountVehicle = Pick<VehicleCycledEnergyRecord, 'customer'>;

const useCustomerCount = (vehicles: CustomerCountVehicle[]): number => {
  return useMemo(() => {
    const uniqueCustomers = new Set<string>();

    for (const vehicle of vehicles) {
      if (vehicle.customer) uniqueCustomers.add(vehicle.customer);
    }

    return uniqueCustomers.size;
  }, [vehicles]);
};

export default useCustomerCount;
